import React from "react";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { employeeColumns } from "./import/employeeColumns";
import { courseColumns } from "./import/courseColumn";
import { sampleEmployeeData } from "core/json/sample_data";

// Static dropdown data
const dropdownDataMap = {
  genders: [
    { label: "Male", value: "M" },
    { label: "Female", value: "F" },
    { label: "Trans", value: "T" },
  ],
  marriagestatus: [
    { label: "Single", value: "Single" },
    { label: "Married", value: "Married" },
    { label: "Widowed", value: "Widowed" },
  ],
  boolOptions: [
    { label: "Yes", value: true },
    { label: "No", value: false },
  ],
  SkilledOrUnskilledOptions: [
    { label: "Skilled", value: "S" },
    { label: "UnSkilled", value: "U" },
  ],
  prcpfTypeOptions: [
    { label: "Full", value: "F" },
    { label: "Graduate", value: "G" },
  ],
  salaryTypeOptions: [
    { label: "Monthly", value: "Monthly" },
    { label: "Daily", value: "Daily" },
    { label: "Hourly", value: "Hourly" },
  ],
  workingMode: [
    { label: "Full Time", value: "Full Time" },
    { label: "Part Time", value: "Part Time" },
  ],
  eatingHabit: [
    { label: "Veg", value: "Veg" },
    { label: "Non Veg", value: "Non Veg" },
    { label: "Veg & Non Veg", value: "Veg &  Non Veg" },
  ],
};

// Convert options into rows in a hidden sheet
const insertOptionsToSheet = (sheet, name, options, col = "A") => {
  options.forEach((opt, i) => {
    sheet.getCell(`${col}${i + 1}`).value = opt.label;
  });
  return `'Options'!$${col}$1:$${col}$${options.length}`;
};

export const generateExcel = async ({ optionData }) => {
  const workbook = new ExcelJS.Workbook();
  const mainSheet = workbook.addWorksheet("Sheet 1");
  const courseSheet = workbook.addWorksheet("Course and Certifications");
  const leaveSheet = workbook.addWorksheet("Leave Types");
  const hiddenSheet = workbook.addWorksheet("Options");

  mainSheet.columns = employeeColumns;
  courseSheet.columns = courseColumns;
  leaveSheet.columns = [
  { header: "Unique Id", key: "uniqueId", width: 30 },
  ...(optionData?.employeeLeaveOptions || []).map((leave) => {
    const name = leave?.label || "Unknown"; // fallback name

    return {
      header: name,
      key: name.toString().replace(/\s+/g, "_").toLowerCase(),
      width: 30,
    };
  }),
];


  // leaveSheet.columns = [
  //   { header: "Unique Id", key: "uniqueId", width: 30 },
  // ].concat(
  //   optionData?.employeeLeaveOptions?.map((leave) => ({
  //     header: leave.leaveName,
  //     key: leave.leaveName,
  //     width: 30,
  //   }))
  // );


  // mainSheet.addRow(sampleEmployeeData);

  // Salary Type options in hidden sheet (column A)
  // Define dropdowns to add: key, options source, column in Options sheet, cell in mainSheet
  const dropdowns = [
    {
      key: "salaryTypeOptions",
      options: dropdownDataMap.salaryTypeOptions,
      optionsCol: "A",
      mainCell: "D2",
    },
    // {
    //   key: "companyOptions",
    //   options: optionData?.companyOptions || [],
    //   optionsCol: "B",
    //   mainCell: "F2",
    // },
    // {
    //   key: "locationOptions",
    //   options: optionData?.locationOptions || [],
    //   optionsCol: "AJ",
    //   mainCell: "DU2",
    // },
    {
      key: "locationOptions",
      options: optionData?.locationOptions || [],
      optionsCol: "B",
      mainCell: "F2",
    },
    {
      key: "momTrade",
      options: optionData?.momTradeOptions || [],
      optionsCol: "C",
      mainCell: "G2",
    },
    {
      key: "trade",
      options: optionData?.netcoTradeOptions || [],
      optionsCol: "D",
      mainCell: "H2",
    },
    {
      key: "departmentCode",
      options: optionData?.departmentOptions || [],
      optionsCol: "E",
      mainCell: "I2",
    },

    {
      key: "workingMode",
      options: dropdownDataMap?.workingMode || [],
      optionsCol: "F",
      mainCell: "L2",
    },
    {
      key: "employmentType",
      options: optionData?.employmentTypeOptions || [],
      optionsCol: "G",
      mainCell: "M2",
    },
    {
      key: "nationality",
      options: optionData?.nationalities || [],
      optionsCol: "H",
      mainCell: "P2",
    },
    {
      key: "passCode",
      options: optionData?.passTypeOptions || [],
      optionsCol: "I",
      mainCell: "R2",
    },
    {
      key: "levyAmountTypes",
      options: optionData?.levyAmountTypeOptions || [],
      optionsCol: "J",
      mainCell: "Y2",
    },
    {
      key: "levyTypes",
      options: optionData?.levyTypeOptions || [],
      optionsCol: "K",
      mainCell: "Z2",
    },
    {
      key: "excludeTime",
      options: dropdownDataMap?.boolOptions || [],
      optionsCol: "L",
      mainCell: "AJ2",
    },
    {
      key: "nsEligible",
      options: dropdownDataMap?.boolOptions || [],
      optionsCol: "M",
      mainCell: "AK2",
    },
    {
      key: "paymentMode",
      options: optionData?.paymodeOptions || [],
      optionsCol: "N",
      mainCell: "AO2",
    },
    {
      key: "groups",
      options: optionData?.group || [],
      optionsCol: "O",
      mainCell: "AR2",
    },
    {
      key: "academicQualification",
      options: optionData?.acadamicOptions || [],
      optionsCol: "P",
      mainCell: "AS2",
    },
    {
      key: "gender",
      options: dropdownDataMap?.genders || [],
      optionsCol: "Q",
      mainCell: "AT2",
    },
    {
      key: "maritalStatus",
      options: dropdownDataMap?.marriagestatus || [],
      optionsCol: "R",
      mainCell: "AU2",
    },
    {
      key: "havingDependants",
      options: dropdownDataMap?.boolOptions || [],
      optionsCol: "S",
      mainCell: "AY2",
    },
    {
      key: "havingKids",
      options: dropdownDataMap?.boolOptions || [],
      optionsCol: "T",
      mainCell: "AZ2",
    },
    {
      key: "eatingHabit",
      options: dropdownDataMap?.eatingHabit || [],
      optionsCol: "U",
      mainCell: "BA2",
    },

    {
      key: "accommodationByCompany",
      options: dropdownDataMap?.accommodationByCompany || [],
      optionsCol: "V",
      mainCell: "BB2",
    },
    {
      key: "country",
      options: optionData?.countryOptions || [],
      optionsCol: "W",
      mainCell: "BK2",
    },
    {
      key: "race",
      options: optionData?.race || [],
      optionsCol: "X",
      mainCell: "BM2",
    },
    {
      key: "employmentStatus",
      options: optionData?.empStatus || [],
      optionsCol: "Y",
      mainCell: "BT2",
    },
    {
      key: "skilledOrUnSkilled",
      options: dropdownDataMap?.SkilledOrUnskilledOptions || [],
      optionsCol: "Z",
      mainCell: "BU2",
    },
    {
      key: "projectCode",
      options: optionData?.projectOptions || [],
      optionsCol: "AA",
      mainCell: "BY2",
    },
    {
      key: "residentialType",
      options: optionData?.residentials || [],
      optionsCol: "AB",
      mainCell: "BZ2",
    },
    {
      key: "contributionCode",
      options: optionData?.contributeOptions || [],
      optionsCol: "AC",
      mainCell: "CA2",
    },
    {
      key: "prcpfType",
      options: dropdownDataMap?.prcpfTypeOptions || [],
      optionsCol: "AF",
      mainCell: "CC2",
    },
    {
      key: "haveOverTimePay",
      options: dropdownDataMap?.boolOptions || [],
      optionsCol: "L",
      mainCell: "CH2",
    },
    {
      key: "haveOverTimePayForExtraHours",
      options: dropdownDataMap?.boolOptions || [],
      optionsCol: "L",
      mainCell: "CI2",
    },
    {
      key: "haveNeedAttendance",
      options: dropdownDataMap?.boolOptions || [],
      optionsCol: "L",
      mainCell: "CN2",
    },
    {
      key: "haveLoginPermission",
      options: dropdownDataMap?.boolOptions || [],
      optionsCol: "L",
      mainCell: "CO2",
    },
    
    {
      key: "haveLessTimeDeduction",
      options: dropdownDataMap?.boolOptions || [],
      optionsCol: "L",
      mainCell: "DJ2",
    },
    {
      key: "isActive",
      options: dropdownDataMap?.boolOptions || [],
      optionsCol: "L",
      mainCell: "DK2",
    },
    {
      key: "haveLessTimeDeduction",
      options: dropdownDataMap?.boolOptions || [],
      optionsCol: "L",
      mainCell: "DL2",
    },

    {
      key: "bankName",
      options: optionData?.bankOptions || [],
      optionsCol: "AG",
      mainCell: "AP2",
    },
    {
      key: "designationCode",
      options: optionData?.designationOptions || [],
      optionsCol: "AD",
      mainCell: "J2",
    },
    {
      key: "employeeType",
      options: optionData?.empTypeOptions || [],
      optionsCol: "AE",
      mainCell: "K2",
    },
    {
      key: "contractType",
      options: optionData?.contarctTypeOptions || [],
      optionsCol: "AH",
      mainCell: "DS2",
    },
    {
      key: "defaultShift",
      options: optionData?.defaultShiftOptions || [],
      optionsCol: "AI",
      mainCell: "DT2",
    },
    // Add more dropdowns as needed
  ];

  // Insert options and set data validation
  dropdowns.forEach(({ options, optionsCol, mainCell }) => {
    options.forEach((opt, idx) => {
      hiddenSheet.getCell(`${optionsCol}${idx + 1}`).value = opt.label;
    });
    if (options.length > 0) {
      mainSheet.getCell(mainCell).dataValidation = {
        type: "list",
        allowBlank: true,
        formulae: [
          `=Options!$${optionsCol}$1:$${optionsCol}$${options.length}`,
        ],
        showDropDown: true,
      };
    }
  });

  // // Fill Employee Type options in hidden sheet (column A)
  // const empTypeOptions = optionData?.empTypeOptions || [];

  // empTypeOptions.forEach((opt, index) => {
  //   hiddenSheet.getCell(`A${index + 1}`).value = opt.label;
  // });

  // mainSheet.getCell("D2").dataValidation = {
  //   type: "list",
  //   allowBlank: true,
  //   formulae: [`=Options!$A$1:$A$${empTypeOptions.length}`],
  //   showDropDown: true,
  // };

  // Hide the sheet
  hiddenSheet.state = "veryHidden";

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  saveAs(blob, "EmployeeTemplate.xlsx");
};
